import React, { useEffect, useState } from 'react';
import { useHistory } from 'react-router-dom';

import Accordion from '../../../../../components/Accordion';
import FormContainer from '../../../../../components/FormContainer';
import Select from '../../../../../components/Inputs/Select';
import StepProgress from '../../../../../components/StepProgress';
import Button from '../../../../../components/Button';
import PageLoader from '../../../../../components/PageLoader';
import Modal from '../../../../../components/Modal';

import { ContainerButton, PageContainer } from '../../../../../styles/styles';

import validate from '../../../../../utils/validateForm';

import { cloneObject } from '../../../../../utils';
import steps from '../../../../../utils/steps.json';

import schema from './schema';

import { useBeneficiarioEventual } from '../../../../../contexts/BeneficiarioEventual/context';

import { buscaEspecialidades, buscaRegiao, buscaLocalidade, buscaDatasDisponiveis } from '../../../../../services';

function DadosCadastro() {
    const history = useHistory();
    const [existeUltimaConsulta] = useState(false);
    const {
        dataConsultaAtendimento,
        setDataEspecialidade,
        setDataLocalidade,
        setDataRegiao,
        setDatasDisponiveis,
        setperiodoDia,
    } = useBeneficiarioEventual();
    const [dataForm, setDataForm] = useState(cloneObject(schema));
    const [loadingButton, setLoadingButton] = useState(false);
    const [pageLoading, setPageLoading] = useState(false);
    const [sucessRegiao, setSucessRegiao] = useState(false);

    const periodoDiaFiltered = [
        {
            codigo: 'null',
            nome: 'Todos',
        },
        {
            codigo: 'M',
            nome: 'Manhã',
        },
        {
            codigo: 'T',
            nome: 'Tarde',
        },
        {
            codigo: 'N',
            nome: 'Noite',
        },
    ];

    const modalMessage = 'Você já possui uma consulta agendada com essa especialidade.';

    async function loadData() {
        setPageLoading(true);

        const especialidades =
            (await buscaEspecialidades(dataConsultaAtendimento.beneficiarioEventual.numCarteira)) || [];

        const especialidadesFiltered = especialidades?.especialidades?.map((element) => ({
            codigo: element.codigo,
            nome: element.descricao,
        }));

        const initialValues = {
            ...dataForm,
            especialidade: {
                ...dataForm.especialidade,
                options: especialidadesFiltered,
            },
        };

        setDataForm({
            ...dataForm,
            ...initialValues,
        });
        setPageLoading(false);
    }

    async function loadDataRegion() {
        setPageLoading(true);
        let buscaRegiaoFiltered = [];
        let buscasRegiao = [];

        buscasRegiao =
            (await buscaRegiao(
                dataConsultaAtendimento.beneficiarioEventual.numCarteira,
                Number(dataForm.especialidade.value)
            )) || [];

        if (buscasRegiao?.length > 0) {
            buscaRegiaoFiltered = buscasRegiao?.map((element) => ({
                codigo: element.codigo,
                nome: element.descricao,
            }));
        } else {
            setSucessRegiao(true);
        }

        const initialValues = {
            regiao: {
                ...dataForm.regiao,
                options: buscaRegiaoFiltered,
            },
            periodoDia: {
                ...dataForm.periodoDia,
                options: periodoDiaFiltered,
            },
        };

        setDataForm({
            ...dataForm,
            ...initialValues,
        });
        setPageLoading(false);
    }

    async function loadDataLocality() {
        setPageLoading(true);
        let localidadeFiltered = [];
        let buscasLocalidade = [];

        buscasLocalidade =
            (await buscaLocalidade(
                dataConsultaAtendimento.beneficiarioEventual.numCarteira,
                Number(dataForm.especialidade.value),
                Number(dataForm.regiao.value)
            )) || [];

        localidadeFiltered = buscasLocalidade?.map((element) => ({
            codigo: element.codigo,
            nome: element.descricao,
        }));

        if (localidadeFiltered.length > 0) {
            const initialValues = {
                localidade: {
                    ...dataForm.localidade,
                    options: localidadeFiltered,
                },
            };

            setDataForm({
                ...dataForm,
                ...initialValues,
            });
        }
        setPageLoading(false);
    }

    async function handleChangeInput(event) {
        const { id, value, unmaskedValue, lookup, ...rest } = event;

        const regiaoClone = cloneObject(dataForm.regiao);
        const localidade = cloneObject(dataForm.localidade);

        if (event.id === 'especialidade') {
            setDataEspecialidade(event);
        }

        if (event.id === 'regiao') {
            setDataRegiao(event);
        }

        if (event.id === 'localidade') {
            setDataLocalidade(event);
        }

        if (event.id === 'periodoDia') {
            setperiodoDia(event);
        }

        const field = {
            ...cloneObject(dataForm[id]),
            value,
            lookup,
            unmaskedValue,
            error: '',
            ...rest,
        };

        setDataForm({
            ...dataForm,
            regiaoClone,
            localidade,
            [id]: field,
        });
    }

    async function handleFowardStep() {
        setLoadingButton(true);
        const { validatedForm, isValid } = validate(dataForm);
        setDataForm({
            ...dataForm,
            ...validatedForm,
        });

        let arrayAuxDataDisponivel = [];

        if (isValid) {
            arrayAuxDataDisponivel = await buscaDatasDisponiveis(
                dataConsultaAtendimento.beneficiarioEventual.numCarteira,
                Number(dataForm.especialidade.value),
                Number(dataForm.localidade.value),
                dataForm.periodoDia.value
            );

            setDatasDisponiveis(arrayAuxDataDisponivel);

            history.push('/dados_beneficiario/consulta_beneficiario_eventual/agendamento_consulta_medico');
        } else {
            setTimeout(() => {
                const firstElementWithError = document.querySelector('.error');

                if (firstElementWithError) {
                    firstElementWithError.scrollIntoView({
                        block: 'center',
                        behavior: 'smooth',
                    });
                }
            }, 300);
        }

        setLoadingButton(false);
    }

    useEffect(() => {
        loadData();
    }, []);

    useEffect(() => {
        if (dataForm.especialidade.value) {
            loadDataRegion();
        }
    }, [dataForm.especialidade.value]);

    useEffect(() => {
        if (dataForm.regiao.value) {
            loadDataLocality();
        }
    }, [dataForm.regiao.value]);

    return (
        <>
            <PageContainer>
                <StepProgress steps={steps.agendamentoConsulta} activeStep={3} />
                <>
                    {!existeUltimaConsulta && (
                        <Accordion title="Selecione especialidade, região e localidade" hasCollapse={false}>
                            <FormContainer>
                                <Select field={{ ...dataForm.especialidade }} onChange={handleChangeInput} />
                                <Select field={{ ...dataForm.regiao }} onChange={handleChangeInput} />
                                <Select field={{ ...dataForm.localidade }} onChange={handleChangeInput} />
                                <Select field={{ ...dataForm.periodoDia }} onChange={handleChangeInput} />
                            </FormContainer>
                            <ContainerButton>
                                <Button id="backStep" type="secondary" onClick={() => history.goBack()}>
                                    Voltar
                                </Button>
                                <Button
                                    id="continueStep"
                                    type="primary"
                                    loading={loadingButton}
                                    onClick={(event) => handleFowardStep(event)}
                                >
                                    Pesquisar
                                </Button>
                            </ContainerButton>
                        </Accordion>
                    )}

                    {existeUltimaConsulta && (
                        <Accordion title="Ultima consulta realizada" hasCollapse={false}>
                            <FormContainer>
                                <Select field={{ label: 'teste ' }} />
                                <ContainerButton>
                                    <Button id="backStep" type="secondary" onClick={() => history.goBack()}>
                                        Voltar
                                    </Button>

                                    <Button id="continueStep" type="primary" onClick={handleFowardStep}>
                                        Pesquisar
                                    </Button>
                                </ContainerButton>
                            </FormContainer>
                        </Accordion>
                    )}
                </>
                <Modal
                    title="Atenção"
                    subtitle={modalMessage}
                    visible={sucessRegiao}
                    onCancel={() => setSucessRegiao(false)}
                    footer={null}
                >
                    <Button
                        type="primary"
                        onClick={() => {
                            setSucessRegiao(false);
                        }}
                    >
                        Ok
                    </Button>
                </Modal>
                <PageLoader loading={pageLoading} />
            </PageContainer>
        </>
    );
}

export default DadosCadastro;
